import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import axios from "axios";
import axiosRetry from "axios-retry";
import { Socket } from "phoenix";

class ApiClient {
  constructor(options) {
    _defineProperty(this, "host", void 0);

    _defineProperty(this, "apiKey", void 0);

    _defineProperty(this, "userToken", void 0);

    _defineProperty(this, "axiosClient", void 0);

    _defineProperty(this, "socket", void 0);

    this.host = options.host;
    this.apiKey = options.apiKey;
    this.userToken = options.userToken || null; // Create a retryable axios client

    this.axiosClient = axios.create({
      baseURL: this.host,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer ".concat(this.apiKey),
        "X-Knock-User-Token": this.userToken
      }
    });

    if (typeof window !== "undefined") {
      this.socket = new Socket("".concat(this.host.replace("http", "ws"), "/ws/v1"), {
        params: {
          user_token: this.userToken,
          api_key: this.apiKey
        }
      });
    }

    axiosRetry(this.axiosClient, {
      retries: 3,
      retryCondition: this.canRetryRequest,
      retryDelay: axiosRetry.exponentialDelay
    });
  }

  makeRequest(req) {
    var _this = this;

    return _asyncToGenerator(function* () {
      try {
        var result = yield _this.axiosClient(req);
        return {
          statusCode: result.status < 300 ? "ok" : "error",
          body: result.data,
          error: undefined,
          status: result.status
        }; // eslint:disable-next-line
      } catch (e) {
        console.error(e);
        return {
          statusCode: "error",
          status: 500,
          body: undefined,
          error: e
        };
      }
    })();
  }

  canRetryRequest(error) {
    // Retry Network Errors.
    if (axiosRetry.isNetworkError(error)) {
      return true;
    }

    if (!error.response) {
      // Cannot determine if the request can be retried
      return false;
    } // Retry Server Errors (5xx).


    if (error.response.status >= 500 && error.response.status <= 599) {
      return true;
    } // Retry if rate limited.


    if (error.response.status === 429) {
      return true;
    }

    return false;
  }

}

export default ApiClient;
//# sourceMappingURL=api.js.map